var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 190,
    viewBox: "0 0 190 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 94.9794C0 94.9862 0 94.9932 0 95C0 95.6754 0.00708008 96.3491 0.0209961 97.0211C50.8828 98.0826 91.9175 139.117 92.979 189.979C93.6511 189.993 94.3247 190 95 190C95.6753 190 96.3489 189.993 97.021 189.979C98.0825 139.117 139.117 98.0826 189.979 97.0211C189.993 96.3491 190 95.6754 190 95V94.9794C138.463 93.915 97.011 51.8099 97 0.0206299C96.335 0.00689697 95.6682 0 95 0C94.3318 0 93.665 0.00689697 93 0.0206299C92.989 51.8099 51.5369 93.915 0 94.9794Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle);
export default __webpack_public_path__ + "static/media/sparkle.cf862ebab0220302ea3521c891dd3b16.svg";
export { ForwardRef as ReactComponent };